import React, { FC } from 'react'
import { Modal, Space, TextBody, TextHeading } from '@ally/metronome-ui'
import allytm from '@ally/allytm'
import { EddFaqsModalContent } from './EddFaqsModalContent'

const headerRef = React.createRef<HTMLHeadingElement>()
export const EddModalContent: React.FC = () => {
  allytm.event('modalView', 'AOS:Early Direct Deposit:FAQ', {
    treatAsPageview: true,
  })

  return (
    <>
      <Space mb="md" as="section">
        <Space mb="sm">
          <TextHeading
            size="md"
            data-testid="edd-modal-title"
            tag="h1"
            ref={headerRef}
            tabIndex={-1}
          >
            Get paid sooner with early direct deposit.
          </TextHeading>
        </Space>
        <TextBody tag="p" size="sm">
          We&apos;re giving you access to your paycheck up to 2 days early with
          early direct deposit. Just set up direct deposit on your Ally Bank
          Spending account. If we see that your payroll provider sends us your
          payment information in advance, we may let you access your money
          sooner.
        </TextBody>
      </Space>
      <EddFaqsModalContent />
    </>
  )
}

export const EarlyDirectDeposit: React.FC<{
  TriggerButton: FC
}> = ({ TriggerButton }) => {
  return (
    <Modal
      content={<EddModalContent />}
      ref={headerRef}
      trigger={<TriggerButton />}
      fullScreenMd
      onDismissCallback={
        /* istanbul ignore next */ (): void => {
          allytm.event('clickEvent', {
            allytmln: 'earlyDirectDeposit-closeX',
            tagName: 'div',
            href: 'href|javascript:void(0);',
          })
        }
      }
    />
  )
}
